<template>
  <b-modal id="deduct-bonus-modal" hide-footer size="sm" centered>
    <template #modal-title>
      <div class="d-flex align-items-center">
        <span class="font-weight-bold">Deduct Bonus Cash</span>
        <b-icon-gift class="ml-1 text-primary"></b-icon-gift>
      </div>
    </template>

    <!-- Subtitle -->
    <div class="text-center mb-1">
      <h5 class="font-weight-bold mb-0 text-black">Select Deposit Match</h5>
      <small class="text-muted">
        Choose from available deposit match to apply.
      </small>
    </div>

    <!-- Select -->
    <b-form-group label="Deposit Match" label-class="text-black">
      <b-form-select
        v-model="option"
        :options="options"
        @mousedown.native="fetchBonusList"
      />
    </b-form-group>

    <!-- Amount -->
    <b-form-group label="Deduct Amount" class="text-black">
      <b-form-input
        v-model="deductAmount"
        placeholder="Enter bonus amount ($)"
        :disabled="!option"
      />
    </b-form-group>

    <!-- Buttons -->
    <b-button
      block
      variant="success"
      class="mb-1 mt-2"
      @click="handleApplyDeductBonus"
      :disabled="loadingAvailableBonus || !option || !deductAmount || loadingBonusDeduct"
    >
      <Spinner v-if="loadingBonusDeduct" />
      <template v-else>SAVE</template>
    </b-button>

    <b-button block variant="outline-secondary" @click="hideModal">
      CANCEL
    </b-button>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";
import {
  BButton,
  BModal,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
  BFormTextarea,
  BIconGift,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { formatDateSend } from "@/helpers/utils";

export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea,
    BIconGift,
    Spinner,
    BRow,
    BCol,
    flatPickr,
    BFormInput,
    BInputGroup,
    vSelect,
  },
  data() {
    const options = [{ value: null, text: "Select Deposit Match" }];
    return {
      option: null,
      options,
      deductAmount: null,
      selectedDeposit: null,
    };
  },
  watch: {
    option(val) {
      const item = this.options.find((i) => i.bonusOfferId === val);
      if (item) this.selectedDeposit = item;
    },
  },
  async mounted() {
    await this.fetchBonusList();
  },
  computed: {
    ...mapState("user/bonus", ["availableBonus", "loadingAvailableBonus", "loadingBonusDeduct"]),
  },
  methods: {
    ...mapActions({
      getListAvailableBonus: "user/bonus/getListAvailableBonus",
      updateBonus: "user/bonus/updateBonus",
      getAvailableBonus: "user/bonus/getAvailableBonus",
    }),
    async fetchBonusList() {
      const data = await this.getListAvailableBonus(
        this.$router.currentRoute.params.id
      );

      if (!data) return this.showToastError(false, "Error fetching list");
      if (Array.isArray(data)) {
        const list = data.map((i) => {
          return {
            ...i,
            value: i.bonusOfferId,
            text: `Total remain: $${i.remain}`,
          };
        });
        this.options = [{ value: null, text: "Select Deposit Match" }, ...list];
      }
    },
    async handleApplyDeductBonus() {
      const res = await this.updateBonus({
        bonusOfferId: this.selectedDeposit.bonusOfferId,
        bonus: -Number(this.deductAmount),
        userId: this.$router.currentRoute.params.id,
      });
      if (res) {
        this.showToastSuccess(true, "Deduct bonus successfully!");
        this.hideModal();
        this.getAvailableBonus(this.$router.currentRoute.params.id);
      }
    },
    hideModal() {
      this.deductAmount = null;
      this.$bvModal.hide("deduct-bonus-modal");
      this.option = null;
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
      formatDateSend,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
